import React, { useMemo } from "react";
import Avatar from "../../../../../components/Avatar";
import { Grid, Tooltip } from "@mui/material";
import { createAvatarName, SanitizedHtml } from "../../../../../utils";
import { useFeedActorMeta } from "../hooks/useFeedActorMeta";
import { useFeedBoardMeta } from "../hooks/useFeedBoardMeta";

function FeedLabelHistory({ history, boardName }) {
  const { actor, avatarStyles, formattedDate, isMobile } = useFeedActorMeta({
    user: history?.response_object?.user_object,
    date: history?.at_time,
  });
  const { boardKeyDisplay, openBoard, openCard } = useFeedBoardMeta(
    boardName,
    history?.card_id
  );

  const { epicData, labelData } = useMemo(() => ({
    epicData: {
      added: history?.response_object?.added_epic,
      removed: history?.response_object?.removed_epic,
    },
    labelData: {
      added: history?.response_object?.added_labels?.filter(label => label !== "") || [],
      removed: history?.response_object?.removed_labels?.filter(label => label !== "") || [],
    }
  }), [history?.response_object]);
  
  if (!history) return null;

  return (

        <Grid
          container
          spacing={2}
          sx={{
            width: isMobile
              ? "calc(100% - 10px) !important"
              : "calc(100% + 16px) !important",
          }}
          className="worklog-item d-flex justify-content-space-between">
          <Grid
            item
            xs={isMobile ? 12 : 9}
            sx={{ paddingLeft: isMobile && "8px !important" }}>
            <div className="d-flex w-100">
              <Avatar
                username={actor.username}
                user_image={actor.userImage}
                title={actor.username}
                className="user-avtar-dropdown user-avatar mr-8"
                style={avatarStyles}>
                    {createAvatarName(actor.username)}  
              </Avatar>
              <div className="w-100">
                <div className="d-flex justify-content-space-between ">
                  <div className={"d-flex align-items-center"}>
                    <div>
                      <Tooltip title={boardKeyDisplay}>
                        <a
                          className="board-anquor cursor-pointer underline"
                          onClick={openBoard}>
                               {boardKeyDisplay}
                        </a>
                      </Tooltip>
                      -
                      <a
                        className="board-anquor cursor-pointer mr-1 underline"
                        onClick={openCard}>
                        {history?.card_id}:
                      </a>
                    </div>
                    <p className="worklog-title mr-2">
                    {actor.username}
                    </p>
                    {epicData.added && (
                      <div className="card-epic-tag mr-1">
                        <p className="card-epic-tag-text">{epicData.added}</p>
                      </div>
                    )}
                    {epicData.removed && (
                      <div className="card-epic-tag mr-1">
                        <p className="card-epic-tag-text">{epicData.removed}</p>
                      </div>
                    )}
                    {
                      <div className="d-flex">
                        {labelData.added.map((label, index) => (
                    <div className="card-level-tag mr-1" key={`added-${label}-${index}`}>
                      <p className="card-level-tag-text">{label}</p>
                    </div>
                  ))}
                      {labelData.removed.map((label, index) => (
                    <div className="card-level-tag mr-1" key={`removed-${label}-${index}`}>
                      <p className="card-level-tag-text">{label}</p>
                    </div>
                  ))}
                      </div>
                    }
                  </div>
                  {/* <p className="hours">{worklog.hours_spent} Hour</p> */}
                </div>
                <SanitizedHtml
                  as="div"
                  className="worklog-worklog comment-content"
                  html={history?.history_text}
                />
              </div>
            </div>
          </Grid>
          <Grid
            item
            xs={isMobile ? 12 : 3}
            sx={{ paddingTop: isMobile && "0px !important" }}>
            <div className={"right-details d-flex"}>
              <p className="worklog-date-time comment-date comment">
                Updated on{" "}
              </p>
              <p className="worklog-date-time comment-date">
                {/* {!sameDay && <img src={lateIcon} className="late-icon" />} */}

                {formattedDate}
              </p>
            </div>
          </Grid>
        </Grid>
     
  );
}

export default FeedLabelHistory;
